import React, { useCallback, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { disableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";
import styles from "./ModalCode.module.sass";
import Icon from "../Icon";
import Card from "../Card";
import TooltipGlodal from "../TooltipGlodal";
import { showSuccess } from "../../services/toast.service";

const ModalCode = ({ visible, onClose, session }) => {
  const modalRef = useRef(null);

  // Génère le titre de la modal basé sur les données de la session
  const getModalTitle = () => {
    if (!session) {
      return "Code de pointage";
    }
    return `Code de pointage - ${session.title}`;
  };

  // Gère le défilement du corps
  useEffect(() => {
    const targetElement = modalRef.current || document.querySelector("#modal-code");

    if (visible) {
      if (targetElement) {
        disableBodyScroll(targetElement);
      }
    } else {
      clearAllBodyScrollLocks();
    }

    return () => {
      clearAllBodyScrollLocks();
    };
  }, [visible]);

  // Gère la touche 'Échap' pour fermer la modale
  const escFunction = useCallback(
    (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    },
    [onClose]
  );

  useEffect(() => {
    document.addEventListener("keydown", escFunction);
    return () => {
      document.removeEventListener("keydown", escFunction);
    };
  }, [escFunction]);

  // Copier le code dans le presse-papiers
  const handleCopyCode = async () => {
    if (!session?.code) return;

    try {
      await navigator.clipboard.writeText(session.code);
      showSuccess("Code copié dans le presse-papiers !");
    } catch (err) {
      console.error('Erreur lors de la copie:', err);
      // Fallback pour les navigateurs qui ne supportent pas l'API clipboard
      const textArea = document.createElement('textarea');
      textArea.value = session.code;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      showSuccess("Code copié dans le presse-papiers !");
    }
  };

  // Sépare le code en chiffres individuels
  const getCodeDigits = () => {
    const code = session?.code || "0000";
    return code.toString().padStart(4, '0').split('');
  };

  // Ne rend le portail que si la modale est visible
  if (!visible) {
    return null;
  }

  return createPortal(
    <>
      <div id="modal-code" className={styles.modal} ref={modalRef}>
        <div className={styles.control}>
          <button className={styles.close} onClick={onClose} aria-label="Fermer la modale">
            <Icon name="close" size="20" />
          </button>
        </div>
        <div className={styles.outer}>
          <Card
            className={styles.card}
            title={getModalTitle()}
            classTitle="title-yellow"
          >
            <div className={styles.codeContainer}>
              <div className={styles.codeHeader}>
                <h3>Saisir un code</h3>
                <p>Entrez votre code d'accès à 4 chiffres</p>
              </div>

              <div className={styles.codeDisplay}>
                {getCodeDigits().map((digit, index) => (
                  <div key={index} className={styles.codeDigit}>
                    {digit}
                  </div>
                ))}
              </div>

            </div>
          </Card>
          <TooltipGlodal />
        </div>
      </div>
    </>,
    document.body
  );
};

export default ModalCode;